(function () {
  'use strict';

  function parseVariantData(root) {
    var node = root.querySelector('[data-ry-variant-data]');
    if (!node) return [];
    try { return JSON.parse(node.textContent || '[]'); }
    catch (error) { return []; }
  }

  function setText(node, value) {
    if (node && typeof value === 'string') node.textContent = value;
  }

  function selectorEscape(value) {
    var stringValue = String(value);
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(stringValue);
    return stringValue.replace(/(["\\])/g, '\\$1');
  }

  function productContext(root, extra) {
    var contextNode = root.querySelector('[data-ry-product-context]');
    var detail = {
      product_id: root.getAttribute('data-product-id') || '',
      product_handle: root.getAttribute('data-product-handle') || '',
      product_title: root.getAttribute('data-product-title') || '',
      product_kind: contextNode ? contextNode.getAttribute('data-product-kind') || '' : '',
      revenue_class: contextNode ? contextNode.getAttribute('data-revenue-class') || '' : '',
      fact_status: contextNode ? contextNode.getAttribute('data-fact-status') || '' : ''
    };

    Object.keys(extra || {}).forEach(function (key) {
      detail[key] = extra[key];
    });

    return detail;
  }

  function pushProductEvent(root, eventName, detail) {
    var payload = productContext(root, detail);
    if (window.RainbowAnalyticsPush) {
      window.RainbowAnalyticsPush(eventName, payload);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, payload));
    }
  }

  function applyMediaSafety(root) {
    var isEvent = root.getAttribute('data-ry-event-page') === 'true';
    var factsNode = root.querySelector('[data-ry-facts-verified]');
    var factsVerified = !factsNode || factsNode.getAttribute('data-ry-facts-verified') === 'true';
    var productMedia = root.querySelector('.ry-product-media');
    var productImage = productMedia && productMedia.querySelector('img');

    if (isEvent && productMedia && productImage) {
      var source = productImage.getAttribute('src') || '';
      var genericFallback = source.indexOf('rainbow-diverse-training-tribe') !== -1;
      if (!factsVerified || genericFallback) {
        productImage.remove();
        productMedia.classList.add('ry-product-media--placeholder');
        productMedia.setAttribute('role', 'img');
        productMedia.setAttribute('aria-label', 'Rainbow Yoga values: movement, play, belonging and connection');
      }
    }

    var genericTrainerImage = root.querySelector('.ry-trainer-card__media img[src*="rainbow-video-poster-kids-circle"]');
    if (genericTrainerImage) {
      var trainerMedia = genericTrainerImage.closest('.ry-trainer-card__media');
      var trainerCard = genericTrainerImage.closest('.ry-trainer-card');
      if (trainerMedia) trainerMedia.remove();
      if (trainerCard) trainerCard.classList.add('ry-trainer-card--text');
    }
  }

  function initProduct(root) {
    if (root.dataset.ryVerifiedProductInitialised === 'true') return;
    root.dataset.ryVerifiedProductInitialised = 'true';

    var declaredLanguage = root.getAttribute('lang');
    if (declaredLanguage) document.documentElement.lang = declaredLanguage;
    applyMediaSafety(root);

    var variants = parseVariantData(root);
    var variantSelect = root.querySelector('[data-ry-variant-select]');
    var variantInput = root.querySelector('[data-ry-variant-id]');
    var planSelect = root.querySelector('[data-ry-selling-plan-select]');
    var paymentOptionsSummary = root.querySelector('[data-ry-payment-options-summary]');
    var fullPaymentSummary = root.querySelector('[data-ry-payment-full-summary]');
    var price = root.querySelector('[data-ry-price]');
    var mobilePrice = root.querySelector('[data-ry-mobile-price]');
    var comparePrice = root.querySelector('[data-ry-compare-price]');
    var addButton = root.querySelector('[data-ry-add-button]');
    var availability = root.querySelector('[data-ry-availability]');
    var paymentWrap = root.querySelector('.ry-purchase-card__accelerated');
    var mobilePurchase = root.querySelector('.ry-mobile-purchase');
    var planRequiredLabel = root.getAttribute('data-ry-plan-required-label') || (declaredLanguage === 'es' ? 'Elige una opción de pago' : 'Choose a purchase option');

    if (planSelect) {
      try {
        var pageUrl = new URL(window.location.href);
        var requestedPlan = pageUrl.searchParams.get('selling_plan') || pageUrl.searchParams.get('plan');
        if (requestedPlan) {
          var matchingOption = planSelect.querySelector('option[value="' + selectorEscape(requestedPlan) + '"]');
          if (matchingOption && !matchingOption.disabled) planSelect.value = String(requestedPlan);
        }
      } catch (error) {}
    }

    function selectedVariantId() {
      return String(variantSelect ? variantSelect.value : (variantInput ? variantInput.value : ''));
    }

    function selectedVariant() {
      var id = selectedVariantId();
      for (var i = 0; i < variants.length; i += 1) {
        if (String(variants[i].id) === id) return variants[i];
      }
      return variants[0] || null;
    }

    function syncPlanAvailability(variant) {
      if (!planSelect || !variant) return;
      var optionalOption = planSelect.querySelector('option[value=""]:not([disabled])');
      var selectedUnavailable = false;
      var firstSupportedPlan = null;

      Array.prototype.forEach.call(planSelect.options, function (option) {
        if (!option.value) return;
        var supported = Boolean(variant.plans && variant.plans[String(option.value)]);
        option.disabled = !supported;
        if (supported && !firstSupportedPlan) firstSupportedPlan = option;
        if (option.selected && !supported) selectedUnavailable = true;
      });

      if (selectedUnavailable) {
        if (optionalOption) {
          planSelect.value = '';
          optionalOption.selected = true;
        } else if (firstSupportedPlan) {
          planSelect.value = firstSupportedPlan.value;
          firstSupportedPlan.selected = true;
        } else {
          planSelect.value = '';
        }
      }
    }

    function render() {
      var variant = selectedVariant();
      if (!variant) return;
      syncPlanAvailability(variant);

      var hasSelectablePlan = Boolean(planSelect && Array.prototype.some.call(planSelect.options, function (option) {
        return option.value && !option.disabled && variant.plans && variant.plans[String(option.value)];
      }));
      if (paymentOptionsSummary) paymentOptionsSummary.hidden = !hasSelectablePlan;
      if (fullPaymentSummary) fullPaymentSummary.hidden = hasSelectablePlan;

      var planId = planSelect ? String(planSelect.value || '') : '';
      var hasOptionalPlan = Boolean(planSelect && planSelect.querySelector('option[value=""]:not([disabled])'));
      var planRequired = Boolean(planSelect && !hasOptionalPlan);
      var planPrice = planId && variant.plans ? variant.plans[planId] : '';
      var planSupported = !planSelect || (planId ? Boolean(planPrice) : !planRequired);
      var displayPrice = planRequired && !planId ? planRequiredLabel : (planPrice || variant.price || '');
      var displayCompare = planId || (planRequired && !planId) ? '' : (variant.comparePrice || '');
      var availableNow = Boolean(variant.available && planSupported && (!planRequired || planId));

      setText(price, displayPrice);
      setText(mobilePrice, displayPrice);
      if (comparePrice) {
        comparePrice.textContent = displayCompare;
        comparePrice.hidden = !displayCompare;
      }
      if (addButton) {
        addButton.disabled = !availableNow;
        addButton.textContent = variant.available && planRequired && !planId ? planRequiredLabel : (availableNow ? addButton.getAttribute('data-label-available') : addButton.getAttribute('data-label-unavailable'));
      }
      if (availability) {
        availability.textContent = variant.available && planRequired && !planId ? planRequiredLabel : (availableNow ? availability.getAttribute('data-label-available') : availability.getAttribute('data-label-unavailable'));
        availability.classList.toggle('ry-purchase-card__availability--unavailable', !availableNow);
      }
      if (paymentWrap) paymentWrap.hidden = !availableNow;
      if (mobilePurchase) mobilePurchase.hidden = !availableNow;
    }

    if (variantSelect) variantSelect.addEventListener('change', function () {
      render();
      pushProductEvent(root, 'select_item', { variant_id: selectedVariantId() });
    });
    if (planSelect) planSelect.addEventListener('change', function () {
      render();
      pushProductEvent(root, 'select_payment_plan', {
        variant_id: selectedVariantId(),
        selling_plan_id: String(planSelect.value || '')
      });
    });
    render();

    var productForm = root.querySelector('[data-ry-product-form] form');
    if (productForm) {
      productForm.addEventListener('submit', function () {
        pushProductEvent(root, 'add_to_cart_intent', {
          variant_id: selectedVariantId(),
          selling_plan_id: planSelect ? String(planSelect.value || '') : ''
        });
      });
    }
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-ry-product-root]');
    for (var i = 0; i < roots.length; i += 1) initProduct(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
